var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3465955(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#E3ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3617 12.3334H13.637C13.4287 12.3332 13.2248 12.3931 13.0497 12.5058C12.8746 12.6185 12.7357 12.7793 12.6496 12.969C12.5635 13.1586 12.5339 13.369 12.5644 13.5751C12.5948 13.7811 12.684 13.974 12.8212 14.1306L18.5651 20.6935C18.7378 20.8911 18.8329 21.1448 18.8327 21.4074V26.6875C18.8327 26.7716 18.8522 26.8546 18.8898 26.9298C18.9275 27.005 18.9821 27.0704 19.0493 27.1209L22.2993 29.5584C22.3798 29.6187 22.4755 29.6555 22.5757 29.6645C22.6759 29.6736 22.7766 29.6545 22.8666 29.6095C22.9565 29.5645 23.0322 29.4954 23.0851 29.4098C23.138 29.3242 23.166 29.2256 23.166 29.125V21.4074C23.1657 21.1448 23.2608 20.8911 23.4336 20.6935L29.1774 14.1295C29.7906 13.4297 29.2922 12.3334 28.3617 12.3334Z",
    stroke: "#407BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3465955);
export default __webpack_public_path__ + "static/media/Frame 3465955.2ba9ca2b021ceda20b9f9450229671bd.svg";
export { ForwardRef as ReactComponent };